/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Reset_CheckinInputs */



/**
* | output |
* | --- |
* | "Reset Check-In" |
*
* @param {Overview_Reset_CheckinInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_reset_checkin = /** @type {((inputs?: Overview_Reset_CheckinInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Reset_CheckinInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser le pointage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reiniciar check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Resetar Check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Resetta Check-In")
	return /** @type {LocalizedString} */ ("Reset Check-In")
});